// ─────────────────────────────────────────────────────────────────
// Glass-i — Purchase Bill API client (Stage 6P.4).
//
// Thin axios wrappers around:
//   /api/erp/purchase/bills/*  (Purchase Bills — 6P.4)
//
// Mirrors the grnApi shape — the `unwrap` helper handles both the
// {data:{data:...}} envelope used by most list/create endpoints and
// the bare {data:...} shape used by a handful of helper routes
// (preview, match-summary, billable balance lookups).
//
// Backend is the source of truth for ALL bill math:
//   billed_qty, billed_amount, tax splits (CGST/SGST/IGST),
//   match deltas vs PO/GRN, billable balances.
// Frontend mirrors for instant UX but never wins.
// ─────────────────────────────────────────────────────────────────

import client from '../../../api/client';

const PB_BASE = '/api/erp/purchase/bills';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const purchaseBillApi = {
  list:                   (params = {}) => client.get(PB_BASE, { params }).then(unwrap),
  getById:                (id)          => client.get(`${PB_BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:                 (payload)     => client.post(PB_BASE, payload).then(unwrap),
  update:                 (id, payload) => client.put(`${PB_BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:                 (id)          => client.delete(`${PB_BASE}/${encodeURIComponent(id)}`).then(unwrap),
  createFromPo:           (poId, payload) =>
    client.post(`${PB_BASE}/from-po/${encodeURIComponent(poId)}`, payload).then(unwrap),
  createFromGrn:          (grnId, payload) =>
    client.post(`${PB_BASE}/from-grn/${encodeURIComponent(grnId)}`, payload).then(unwrap),
  preview:                (payload)     =>
    client.post(`${PB_BASE}/preview`, payload).then(unwrap),
  match:                  (id)          =>
    client.post(`${PB_BASE}/${encodeURIComponent(id)}/match`).then(unwrap),
  approve:                (id)          =>
    client.post(`${PB_BASE}/${encodeURIComponent(id)}/approve`).then(unwrap),
  cancel:                 (id, { reason } = {}) =>
    client.post(`${PB_BASE}/${encodeURIComponent(id)}/cancel`, { reason }).then(unwrap),
  matchSummary:           (id)          =>
    client.get(`${PB_BASE}/${encodeURIComponent(id)}/match-summary`).then(unwrap),
  billableBalanceForPo:   (poId)        =>
    client.get(`${PB_BASE}/po/${encodeURIComponent(poId)}/billable-balance`).then(unwrap),
  billableBalanceForGrn:  (grnId)       =>
    client.get(`${PB_BASE}/grn/${encodeURIComponent(grnId)}/billable-balance`).then(unwrap)
};

export default { purchaseBillApi };
